"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { Facebook, Instagram, Twitter, MapPin, Phone, Mail, CreditCard, Banknote } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}><Link to="/OurStoryPage" className="text-muted-foreground hover:text-primary transition-colors font-sans">Our Story</Link></li>
        <li data-index={1}><Link to="/WeddingDetailsPage" className="text-muted-foreground hover:text-primary transition-colors font-sans">Wedding Details</Link></li>
        <li data-index={2}><Link to="/RSVPPage" className="text-muted-foreground hover:text-primary transition-colors font-sans">RSVP</Link></li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors font-sans">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function BrandFooter() {
  const currentYear = new Date().getFullYear();
  return <footer data-section-id="262920" id="footer" className="bg-muted text-foreground pt-16 pb-8 px-6 md:px-12 font-sans text-[10px] leading-relaxed tracking-widest">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          
          {}
          <div className="flex flex-col items-start">
            <Link to="/HomePage" className="mb-6 inline-block">
              <WvcLogo className="h-8 w-auto text-primary" />
            </Link>
            <p className="text-muted-foreground mb-6 max-w-xs font-serif italic text-sm">
              Celebrating the union of Jane & Liam. A digital keepsake of our love story and the beginning of our forever together.
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default text-xs tracking-[0.2em] uppercase mb-6 text-foreground">Navigation</h3>
            <MenuProvider menu_id="17">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default text-xs tracking-[0.2em] uppercase mb-6 text-foreground">Guest Info</h3>
            <ul className="space-y-3">
              <li data-index={0}>
                <Link to="/WeddingDetailsPage" className="text-muted-foreground hover:text-primary transition-colors font-sans">
                  Travel & Stay
                </Link>
              </li>
              <li data-index={1}>
                <Link to="/WeddingDetailsPage" className="text-muted-foreground hover:text-primary transition-colors font-sans">
                  Attire Guide
                </Link>
              </li>
              <li data-index={2}>
                <Link to="/RSVPPage" className="text-muted-foreground hover:text-primary transition-colors font-sans">
                  Registry
                </Link>
              </li>
              <li data-index={3}>
                <Link to="/RSVPPage" className="text-muted-foreground hover:text-primary transition-colors font-sans">
                  RSVP Online
                </Link>
              </li>
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default text-xs tracking-[0.2em] uppercase mb-6 text-foreground">Get In Touch</h3>
            <ul className="space-y-4 mb-8">
              <li className="flex items-start gap-3 text-muted-foreground font-sans" data-index={0}>
                <MapPin className="size-4 shrink-0 mt-0.5" />
                <span>The Grand Estate, London, United Kingdom</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground font-sans" data-index={1}>
                <Phone className="size-4 shrink-0" />
                <span>+44 20 7946 0000</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground font-sans" data-index={2}>
                <Mail className="size-4 shrink-0" />
                <span>hello@janeandliam.com</span>
              </li>
            </ul>
            
            <div className="flex items-center gap-3">
              <Button variant="ghost" size="icon" asChild className="h-8 w-8 rounded-md hover:bg-accent hover:text-accent-foreground text-muted-foreground">
                <Link to="#" aria-label="Instagram">
                  <Instagram className="size-4" />
                </Link>
              </Button>
              <Button variant="ghost" size="icon" asChild className="h-8 w-8 rounded-md hover:bg-accent hover:text-accent-foreground text-muted-foreground">
                <Link to="#" aria-label="Facebook">
                  <Facebook className="size-4" />
                </Link>
              </Button>
              <Button variant="ghost" size="icon" asChild className="h-8 w-8 rounded-md hover:bg-accent hover:text-accent-foreground text-muted-foreground">
                <Link to="#" aria-label="Twitter">
                  <Twitter className="size-4" />
                </Link>
              </Button>
            </div>
          </div>

        </div>

        <Separator className="bg-border/20 mb-6" />

        {}
        
      </div>
    </footer>;
}